import { isPaymentReservationResponse } from './../../../../entities/paymentReservation';
import { IReservationModel, reservationModelToServiceSum } from 'src/entities/reservation';
import { calculateSubtotal, IServiceDetails, IServiceSubtotal, PaymentMethod } from 'src/entities/service';
import { IReservationEndUser } from 'src/entities/user';
import { StepType } from 'src/services/getStepOrder';
import { ISendReservationResponse } from '../ReservationEnd';

export const getPaymentNeed = (isPaymentEnabled: boolean | undefined, isPayable: boolean | undefined): boolean => {
    return (isPaymentEnabled && isPayable) || false;
}

export const getPaymentNeedWithPrice = (isPaymentEnabled: boolean | undefined, service: IServiceDetails | undefined) => {
    if (isPaymentEnabled && service) {
        return (service.Payable && service.Price !== 0);
    }
    return false;
}

export const advanceOrFullPrice = (paymentMethod?: PaymentMethod): boolean => {
    if (paymentMethod) {
        return (paymentMethod === PaymentMethod.Advance || paymentMethod === PaymentMethod.FullPrice);
    }
    return false;
}

export const getSubtotal = (reservations: IReservationModel[]): IServiceSubtotal | null => {
    const servicePriceData = reservations
        .filter(reservation => getServiceFromReservation(reservation).Payable)
        .map(reservation => reservationModelToServiceSum(reservation));
    return servicePriceData.length ? calculateSubtotal(servicePriceData) : null;
}

export const isValidSubtotal = (reservations: IReservationModel[]): boolean => {
    const subTotal = getSubtotal(reservations);
    if (subTotal) {
        return subTotal.Price !== 0;
    }
    return false;
}

export const getServiceFromReservation = (reservation: IReservationModel) => {
    return (reservation[StepType.Service] || reservation[StepType.Timetable]?.service)!;
}

export const getServicesFromReservations = (reservationList: IReservationModel[]) => {
    return reservationList.map(r => getServiceFromReservation(r));
}

export const isReservationEndUserDirty = (reservationEndUser: IReservationEndUser): boolean => {
    return isDirty(
        reservationEndUser.InvoiceDetails
            ? {
                ...reservationEndUser,
                InvoiceDetails: {
                    ...reservationEndUser.InvoiceDetails,
                    Country: ''
                }
            }
            : reservationEndUser
    )
}

export const isDirty = (object: any): boolean => {
    return Object.values(object).some(x => {
        if (x !== null && x !== '' && x !== undefined && x !== false) {
            if (typeof x === 'object') {
                return isDirty(x);
            }
            return true;
        }
        return false;
    });
}

export const transformResponse = (response: any): ISendReservationResponse | null => {
    const result: ISendReservationResponse = {
        ReservedReservations: null,
        PaymentReservationResponse: null
    }

    if (response && response.constructor === Array) {
        const paymentReservationResponse = response[1];
        if (paymentReservationResponse && isPaymentReservationResponse(paymentReservationResponse)) {
            result.ReservedReservations = response[0];
            result.PaymentReservationResponse = paymentReservationResponse;
        }
        else {
            result.ReservedReservations = response;
        }
    }
    else if (response && isPaymentReservationResponse(response)) {
        result.PaymentReservationResponse = response;
    }
    else {
        return null;
    }

    return result;
}